import React from "react";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import { Box, Typography, Grid } from "@mui/material";
import { typo } from "../../../assets/fonts/font";
import colorConfigs from "../../../configs/colorConfigs";
import homePageStyles from "../../../styles/PublicPage/home";
import { getCollections } from "../../../api/CollectionAPI";
import { getSkus } from "../../../api/SkuAPI";
import SingleProductPage from "./SingleProductPage";
import CustomButton from "../../common/Button/CustomButton";
import { ISkuDetail } from "../../../models/ISkuDetail";

const ShopAllPage: React.FC = () => {
  const navigate = useNavigate();

  // Fetch all collections
  const { data: collectionsData, error: collectionsError } = useSWR(
    "getCollections",
    getCollections
  );

  // Fetch all products
  const { data: productData, error: productError } = useSWR(
    "getSkus",
    getSkus
  );

  if (collectionsError || productError) {
    return <div>Failed to fetch data.</div>;
  }

  if (!collectionsData || !productData) {
    return <div>Loading...</div>;
  }

  // Function to limit the number of products displayed per collection
  const getLimitedProducts = (collectionId: number, limit: number) => {
    return productData
    .filter((product: { collections: number[] }) =>
      product.collections.includes(Number(collectionId))
    )
    .slice(0, limit);
  };

  return (
    <Box sx={homePageStyles.Box}>
      <Typography
        sx={{
          ...typo.sectionHeadline,
          color: colorConfigs.greytext,
          zIndex: 2,
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 4,
        }}
      >
        All Products
      </Typography>
      <Box
        sx={{
          maxWidth: "1200px",
          width: "90%",
          display: "flex",
          flexDirection: "column",
          background: colorConfigs.secondary,
          justifyContent: "center",
          margin: "auto",
        }}
      >
        {collectionsData.map((collection: any) => (
          <Box key={collection.id} sx={{ paddingY: 6 }}>
            <Typography
              sx={{
                ...typo.sectionHeadline,
                color: colorConfigs.greytext,
                zIndex: 2,
                display: 'flex',
                justifyContent: 'center',
                paddingBottom: 4,
              }}
            >
              {collection.name}
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {getLimitedProducts(collection.id, 4).map((product: ISkuDetail) => (
                <Grid
                  item
                  key={product.name}
                  xs={6}
                  sm={6}
                  md={4}
                  lg={3}
                >
                  <Box>
                    <SingleProductPage product={product} />
                  </Box>
                </Grid>
              ))}
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
              <CustomButton
                sx={{ width: "30%" }}
                buttonType="primary"
                onClick={() => navigate(`/collections/${collection.slug}`)}
              >
                View More
              </CustomButton>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ShopAllPage;